
<template>
    <v-btn
      color="primary"
      class="text-none"
      rounded
      depressed
      :loading="isSelecting"
      @click="onButtonClick"
      icon
      small
    >
      <v-icon left> mdi-cloud-upload </v-icon>
    <input
      ref="uploader"
      class="d-none"
      type="file"
      accept="*.docx"
      @change="onFileChanged"
    />
    </v-btn>
</template>


<script>
export default {
  name: 'InputFileDialog',
  props: {
    current_qunit: Object,
  },
  data: () => ({
    defaultButtonText: 'Select template for report',
    selectedFile: null,
    isSelecting: false,
  }),
  computed: {
    buttonText() {
      return this.selectedFile ? this.selectedFile.name : this.defaultButtonText
    },
  },
  methods: {
    onButtonClick() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true },
      )

      this.$refs.uploader.click()
    },
    onFileChanged(e) {
      this.selectedFile = e.target.files[0]

      // do something
      this.$emit('file_choosed', this.current_qunit, e.target.files[0])
    },
  }
}
</script>
<style lang="scss">
@import '@/sass/explorer.scss';
</style>